<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "offline" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 24 24'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <!-- eslint-disable max-len -->
        <path
            d = 'M7.31034 7.33836H8.96552M7.31034 10.6487H8.96552M15.0345 13.9591H16.6897M15.0345 10.6487H16.6897M12.2759 20V5.10345C12.2759 4.49403 11.7818 4 11.1724 4H5.10345C4.49403 4 4 4.49403 4 5.10345V18.8966C4 19.506 4.49403 20 5.10345 20H12.2759ZM12.2759 20H18.8966C19.506 20 20 19.506 20 18.8966V8.41379C20 7.80437 19.506 7.31034 18.8966 7.31034H12.8276'
            stroke-width = '1.5'
            stroke-linecap = 'round'
            stroke-linejoin = 'round'
            vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
        </path>
    <!-- eslint-enable -->
</svg>